import React from "react";
import { Instagram, Twitter, Facebook } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const quickLinks = [{
    label: "HOME",
    href: "/HomePage"
  }, {
    label: "SERVICES",
    href: "#"
  }, {
    label: "GALLERY",
    href: "#"
  }, {
    label: "CONTACT",
    href: "#"
  }];
  const legalLinks = [{
    label: "PRIVACY POLICY",
    href: "#"
  }, {
    label: "TERMS OF SERVICE",
    href: "#"
  }, {
    label: "COOKIE POLICY",
    href: "#"
  }, {
    label: "ACCESSIBILITY",
    href: "#"
  }];
  const socialLinks = [{
    icon: Instagram,
    href: "https://www.instagram.com/",
    label: "Instagram"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }];
  return <section data-section-id="1347" id="footer" className="dark bg-background text-foreground py-8 md:py-20 px-5 md:px-16 border-t border-zinc-900">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
          {}
          <div className="space-y-6">
            <Link to="/HomePage" className="block">
              
            </Link>
            <p className="text-zinc-500 text-sm leading-7 max-w-xs uppercase tracking-widest">
              High-end luxury flooring solutions. Specializing in industrial durability with a gallery-grade aesthetic for modern spaces.
            </p>
          </div>

          {}
          <div>
            <h3 className="text-lg md:text-xs font-bold mb-4 md:mb-6 tracking-[0.2em] text-white uppercase">Navigation</h3>
            <Select onValueChange={value => {
            if (value) window.location.href = value;
          }}>
              <SelectTrigger className="w-full bg-transparent border-zinc-800 text-zinc-500 text-sm md:text-xs tracking-widest uppercase rounded-none focus:ring-0">
                <SelectValue placeholder="SELECT PAGE" />
              </SelectTrigger>
              <SelectContent className="bg-zinc-950 border-zinc-800 rounded-none">
                {quickLinks.map((link, i) => <SelectItem key={i} value={link.href} data-index={i} className="text-zinc-500 focus:bg-zinc-900 focus:text-white text-xs tracking-widest uppercase cursor-pointer">
                    {link.label}
                  </SelectItem>)}
              </SelectContent>
            </Select>
          </div>

          {}
          <div>
            <h3 className="text-lg md:text-xs font-bold mb-4 md:mb-6 tracking-[0.2em] text-white uppercase">Legal</h3>
            <Select onValueChange={value => {
            if (value) window.location.href = value;
          }}>
              <SelectTrigger className="w-full bg-transparent border-zinc-800 text-zinc-500 text-sm md:text-xs tracking-widest uppercase rounded-none focus:ring-0">
                <SelectValue placeholder="LEGAL INFO" />
              </SelectTrigger>
              <SelectContent className="bg-zinc-950 border-zinc-800 rounded-none">
                {legalLinks.map((link, i) => <SelectItem key={i} value={link.href} data-index={i} className="text-zinc-500 focus:bg-zinc-900 focus:text-white text-xs tracking-widest uppercase cursor-pointer">
                    {link.label}
                  </SelectItem>)}
              </SelectContent>
            </Select>
          </div>

          {}
          <div>
            <h3 className="text-lg md:text-xs font-bold mb-4 md:mb-6 tracking-[0.2em] text-white uppercase">Connect</h3>
            <div className="flex gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} to={social.href} newTab className="group flex items-center justify-center w-10 h-10 md:w-8 md:h-8 rounded-none bg-transparent transition-all duration-300" aria-label={social.label} data-index={i}>
                    <Icon className="w-5 h-5 text-zinc-500 group-hover:text-white transition-colors duration-300" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        <Separator className="bg-zinc-900 mb-6 md:mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm md:text-[10px] text-zinc-600 uppercase tracking-[0.15em]">
          <p>&copy; {currentYear} V.V. All rights reserved.</p>
          <p className="flex gap-6">
            <span>Industrial Luxury.</span>
            <span>Los Angeles, CA</span>
          </p>
        </div>
      </div>
    </section>;
}